'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var JobSegment = function JobSegment(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("path", {
    fill: "none",
    d: "M0,0h24v24H0V0z"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M4,6H2v14c0,1.1,0.9,2,2,2h14v-2H4V6z"
  }), React__default["default"].createElement("path", {
    d: "M20,2H8C6.9,2,6,2.9,6,4v12c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2V4C22,2.9,21.1,2,20,2z M20.562,14.859l-1.402,1.402\n            c-0.243,0.243-0.608,0.243-0.854,0l-5.545-5.545c-1.4,0.549-3.046,0.244-4.203-0.914C7.339,8.584,7.034,6.756,7.765,5.294\n            l2.682,2.62l1.828-1.828l-2.621-2.62c1.463-0.67,3.291-0.427,4.511,0.792c1.156,1.158,1.461,2.803,0.913,4.204l5.545,5.544\n            C20.866,14.19,20.866,14.616,20.562,14.859z"
  })));
};

var JobSegment$1 = iconStyles()(JobSegment);

module.exports = JobSegment$1;
